import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useMember} from 'src/feature/members/hook'
import {useEffect, useState} from 'react'
import FilterDrawerActivities from '../List/FilterDrawerActivities'
import moment from 'moment'

const MemberDetailActivities = ({
  loading,
  customerID,
}: {
  loading: boolean
  customerID: string
  search: string
  setSearch: any
}) => {
  const intl = useIntl()

  const {detailTab, listFilterActivities, listFilterActivitiesSet} = useMember()
  const [open, setOpen] = useState(false)

  const data = detailTab?.Activities?.dataList
  const paging = detailTab?.Activities?.paging || {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'id',
      dataIndex: 'id',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.ORDER_ID'}),
    },
    {
      key: 'createdOn',
      dataIndex: 'createdOn',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.DATE_TIME'}),
      render: (text: string) => <>{moment.utc(text).format('DD/MM/YYYY HH:mm')}</>,
    },
    {
      key: 'packageName',
      dataIndex: 'packageName',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.PACKAGE.PACKAGE_NAME'}),
    },
    {
      key: 'packageItem',
      dataIndex: 'packageItem',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.PACKAGE.PACKAGE_ITEM'}),
    },
    {
      key: 'storeName',
      dataIndex: 'storeName',
      title: intl.formatMessage({id: 'STORE.LIST.NAME_2'}),
    },
    {
      key: 'Credit',
      dataIndex: 'credit',
      title: 'Credit Used',
    },
  ]

  const getuserIDParam = () => {
    const path = window.location.pathname
    const pathParts = path.split('/')
    const userID = pathParts[pathParts.length - 1]
    return userID
  }

  useEffect(() => {
    if (
      listFilterActivities?.filterList.length > 0 ||
      listFilterActivities?.paging?.currentPageNumber > 1
    ) {
      listFilterActivitiesSet({
        ...listFilterActivities,
        filterList: [],
        paging: {
          ...listFilterActivities.paging,
          currentPageNumber: 1,
        },
      })
    }
  }, [])

  return (
    <>
      <FilterDrawerActivities
        memberId={getuserIDParam()}
        setOpen={setOpen}
        open={open}
        customerID={customerID}
      />
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <div>
              <h3 className='fw-bold mb-2 mt-5'>{intl.formatMessage({id: 'MENU.ACTIVITIES'})}</h3>
              <p className='text-muted fw-normal fs-6 w-75'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.ACTIVITIES_TOOLTIP'})}
              </p>
            </div>
          </div>
          <div className='card-toolbar'>
            <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                <button className='btn btn-light' onClick={() => setOpen(true)}>
                  <i className='bi bi-sliders fs-4 me-4'></i>
                  {intl.formatMessage({id: 'GLOBAL.FILTER'})}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <Table
              loading={loading}
              dataSource={data}
              tableName={'memberActivities'}
              columns={Columns}
              pagination={{
                current: paging.currentPageNumber,
                pageSize: paging.pageSize,
                total: paging.totalCount,
                onChange: (page: any) => {
                  if (!detailTab || !detailTab.Activities) return
                  const {pageSize, current} = page
                  const currentPage =
                    pageSize !== detailTab.Activities.paging.pageSize ? 1 : current

                  listFilterActivitiesSet({
                    ...listFilterActivities,
                    paging: {
                      ...listFilterActivities.paging,
                      pageSize,
                      currentPageNumber: currentPage,
                    },
                  })

                  /* detailTabSet({
                    ...detailTab,
                    Transaction: {
                      ...detailTab.Transaction,
                      paging: {
                        ...paging,
                        currentPageNumber: currentPage,
                        pageSize: pageSize,
                      },
                    },
                  }) */
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default MemberDetailActivities
